module.exports = __webpack_public_path__ + "img/alpha1.d8bc36f1.png";